export default "__VITE_ASSET__D$3I_FC4__"